export class LotoHistoryItem {
  date: string;
  numbers: number[];
}
